import React from "react";
import "./StyleOne.style.scss";
import arrayImgs from "../../imgs/scammer";
import SliderScammerComponent from "../slider/Slider_scammer";

export default function StepOne() {
    const arrayText = [
        "Оплатити доставку Justin можна лише у відділенні або мобільному додатку Justin. Justin має єдиний офіційний сайт (https://justin.ua/) та мобільний додаток (IOS Android). Не переходьте за посиланнями, які вам надсилають у особистих повідомленнях нібито для купівлі товару/скасування угоди/повернення ваших коштів тощо. ",
        "Відстежуйте посилки виключно з офіційного сайту або мобільного додатку (IOS Android).",
        "При купівлі в маркетплейсах користуйтеся послугою «Надійна покупка» (на olx.ua це «OLX доставка», на prom.ua та bigl.ua – «Покупка без ризику», на shafa.ua – «Безпечна оплата»).",
        "Не надсилайте передплату на картку незнайомця. Частіше за все це шахрайські схеми.",
        "Відправляючи товар, використовуйте номер ЕН, що вказаний в особистому кабінеті торгового майданчика. Не використовуйте номер ЕН, який надсилають вам особистим повідомленням сторонні особи (навіть від імені торгового майданчика).",
        "Не переводьте обговорення деталей в месенджери. Якщо ви замовляйте з маркетплейcів (olx.ua, shafa.ua, prom.ua та bigl.ua), обговорюйте деталі в чаті цих сервісів. Не погоджуйтесь переходити на месенджери!",
    ]
    return <div className="step_one_scammer">
        <div className="wrapper_text">
            <h3>Як не потрапити в пастку до шахрая</h3>
            <p>6 правил для безпеки онлайн-покупок:</p>
            <SliderScammerComponent arrayText={arrayText}/>
        </div>
        <img id="scammer" src={arrayImgs.Scammer} alt="scammer"/>
    </div>
}